import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-canvas pb-14" data-id="element-81" data-mp="1o3x3nprb6w3l">
      <div className="mx-auto max-w-page px-5" data-id="element-82" data-mp="1o2vk0ww891a9">
        <div className="rounded-3xl border-2 border-night bg-paper p-6 text-center shadow-card sm:p-8" data-id="element-83" data-mp="223eppxd7zv99">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-night" data-id="element-84" data-mp="1x4l93w2mzo4v">
            <ShieldCheckIcon className="h-7 w-7 text-amber" aria-hidden="true" data-id="element-85" data-mp="19ehdobzlquoy" />
          </span>
          <h2 className="mt-4 font-display text-[26px] font-black leading-tight text-night sm:text-[32px]" data-id="element-86" data-mp="14fxu2i8hduzr">
            Garantía 7 días — sin preguntas
          </h2>
          <p className="mx-auto mt-3 max-w-md text-[14.5px] leading-relaxed text-muted" data-id="element-87" data-mp="1j6n8rul5hs8d">
            Probá el Protocolo completo durante 7 días. Si sentís que no es para vos, escribís un mail y te
            devolvemos el <strong className="font-extrabold text-night" data-id="element-88" data-mp="qlwrteiblpun">100% de tu dinero</strong>. Sin
            formularios, sin justificaciones, sin que te intenten convencer.
          </p>
          <p className="mt-4 inline-block rounded-full bg-flame-soft px-4 py-2 text-[12.5px] font-extrabold uppercase tracking-wide text-flame-dark" data-id="element-89" data-mp="oz9maymov7ki">
            El riesgo lo asumimos nosotros
          </p>
        </div>
      </div>
    </section>;
}